
import { useStore } from "vuex";
import { computed, defineAsyncComponent, defineComponent } from "vue";

import Party from "@/components/Party/Party.vue";
import Chat from "@/components/Chat/Chat.vue";
import RoundAnnouncer from "@/components/Games/RoundAnnouncer.vue";
import ScoreAnnouncer from "@/components/Games/ScoreAnnouncer.vue";
import GameLoader from "@/components/Games/GameLoader.vue";

export default defineComponent({
  setup() {
    const store = useStore();
    const roomComponent = computed(() => store.getters.getRoomComponent);
    return { roomComponent };
  },
  components: {
    Party,
    Chat,
    RoundAnnouncer,
    ScoreAnnouncer,
    WordSelector: defineAsyncComponent({
      loader: () => import("@/components/Games/WordSelector.vue"),
      loadingComponent: GameLoader,
    }),
    Shuffler: defineAsyncComponent({
      loader: () => import("@/components/Games/Shuffler.vue"),
      loadingComponent: GameLoader,
    }),
    Riddles: defineAsyncComponent({
      loader: () => import("@/components/Games/Riddles.vue"),
      loadingComponent: GameLoader,
    }),
    Guess: defineAsyncComponent({
      loader: () => import("@/components/Games/Guess.vue"),
      loadingComponent: GameLoader,
    }),
    TurnAnnouncer: defineAsyncComponent({
      loader: () => import("@/components/Games/TurnAnnouncer.vue"),
      loadingComponent: GameLoader,
    }),
  },
});
